import { render } from "./CandidateForm.vue?vue&type=template&id=30986742"
import script from "./CandidateForm.vue?vue&type=script&lang=js"
export * from "./CandidateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__